/* Club Explorador — fb-cart.js
   Motxilla (calaix i pàgina /cart): els botons que no són de quantitat.
   - Suggeriment del pack: «Cambiar al Pack» canvia el llibre (i, si hi són, els recursos digitals de la mateixa edició)
     pel pack de la mateixa edició, amb una sola petició /cart/update.js.
   - Edició: «Cambiar a la edición en catalán / castellano» canvia cada producte pel seu germà de l'altra edició i manté
     les quantitats, amb una sola petició /cart/update.js (les dades surten de snippets/cart-edition.liquid).
   - Codi de descompte: l'aplica i el treu amb /cart/update.js («discount»).
   Les peticions i el repintat són els de la motxilla de theme.js (window.ClubCart): una petició amb «sections», en fila
   amb la resta d'accions; el calaix i la pàgina /cart es pinten amb la mateixa resposta i els seus elements arrel no es
   substitueixen mai (només en canvia el contingut). */
(function () {
  'use strict';

  function cart() { return window.ClubCart; }
  function noop() {}

  // Àmbit d'un control: el calaix o la secció de la pàgina /cart.
  function scopeOf(el) {
    return el.closest('[data-cart-drawer]') || el.closest('[data-fb-cart-page]') || document;
  }

  function setButtonBusy(button, busy) {
    button.disabled = busy;
    if (busy) button.setAttribute('aria-busy', 'true');
    else button.removeAttribute('aria-busy');
  }

  function variantsInCart(data) {
    var found = {};
    (data && data.items || []).forEach(function (item) { found[String(item.variant_id)] = true; });
    return found;
  }

  // Els botons de canvi (al pack i d'edició) calculen la petició quan els arriba el torn a la fila de la motxilla
  // (ClubCart.mutate amb una funció), amb el botó tal com és llavors a la motxilla repintada, no amb el que s'ha clicat:
  // si just abans s'ha clicat «+» o «−», el canvi espera la resposta i fa servir les quantitats noves. Si el botó ja no
  // hi és (p. ex. ara hi ha dos llibres i surt «Ver el Pack»), no es fa res: la motxilla ja mostra què toca.
  // Des del clic fins a la resposta, les quantitats de les línies no es poden tocar ({ lock: true }).

  /* ---------------- Suggeriment del pack ---------------- */
  // Petició del canvi al pack: les línies que el pack substitueix, a 0, i el pack de la mateixa edició.
  function packPlan(button) {
    var packVariant = button.dataset.packVariant;
    var quantity = parseInt(button.dataset.quantity, 10) || 1;
    var remove = (button.dataset.remove || '').split(',').filter(Boolean);
    if (!packVariant || !remove.length) return null;
    var updates = {};
    remove.forEach(function (key) { updates[key] = 0; });
    updates[packVariant] = quantity;
    return { updates: updates, packVariant: packVariant };
  }

  function swapForPack(button) {
    var C = cart();
    var scope = scopeOf(button);
    var box = button.closest('[data-cart-upsell]');
    var errorEl = box && box.querySelector('[data-cart-upsell-error]');
    var fallback = errorEl && errorEl.dataset.default;
    var packVariant = null;
    if (!C || !packPlan(button)) return;

    setButtonBusy(button, true);
    if (errorEl) errorEl.hidden = true;
    C.mutate('cart/update.js', function () {
      var fresh = scope.querySelector('[data-cart-upsell-swap]');
      var plan = fresh && packPlan(fresh);
      if (!plan) return null;
      setButtonBusy(fresh, true);
      packVariant = plan.packVariant;
      return { updates: plan.updates };
    }, { lock: true })
      .then(function (data) {
        if (!data) {
          if (button.isConnected) setButtonBusy(button, false);
          return;
        }
        // Si el pack no hi és (esgotat…), es diu com un error.
        if (!variantsInCart(data)[String(packVariant)]) throw {};
        var checkout = scope.querySelector('[name="checkout"]');
        if (checkout) checkout.focus({ preventScroll: true });
      })
      .catch(function (error) {
        var message = C.errorText(error, fallback);
        C.refresh().catch(noop).then(function () {
          var freshError = scope.querySelector('[data-cart-upsell-error]');
          if (freshError && message) {
            freshError.textContent = message;
            freshError.hidden = false;
          }
        });
      });
  }

  /* ---------------- Edició (castellà ↔ català) ---------------- */
  // Petició del canvi d'edició (data-lines del botó): cada producte de l'altra edició, a 0, i el seu germà de l'edició
  // triada amb la quantitat final (la que ja hi era d'aquesta edició + la que hi passa).
  function editionPlan(button, target) {
    var lines;
    try { lines = JSON.parse(button.dataset.lines || '[]'); } catch (e) { lines = []; }
    var totals = {};
    var moved = {};
    var updates = {};
    lines.forEach(function (line) {
      if (line.edition === target) totals[line.variant] = (totals[line.variant] || 0) + line.qty;
    });
    lines.forEach(function (line) {
      if (line.edition === target || !line.twin) return;
      updates[line.key] = 0;
      totals[line.twin] = (totals[line.twin] || 0) + line.qty;
      moved[line.twin] = true;
    });
    var twins = Object.keys(moved);
    if (!twins.length) return null;
    twins.forEach(function (variant) { updates[variant] = totals[variant]; });
    return { updates: updates, twins: twins };
  }

  function setEditionBusy(button, busy) {
    var box = button.closest('[data-cart-edition]');
    if (!box) return setButtonBusy(button, busy);
    box.querySelectorAll('[data-cart-edition-swap]').forEach(function (b) { setButtonBusy(b, busy); });
    var errorEl = box.querySelector('[data-cart-edition-error]');
    if (errorEl && busy) errorEl.hidden = true;
  }

  function swapEdition(button) {
    var C = cart();
    var scope = scopeOf(button);
    var target = button.getAttribute('data-cart-edition-swap');
    var twins = [];
    if (!C || (target !== 'es' && target !== 'ca') || !editionPlan(button, target)) return;

    setEditionBusy(button, true);
    C.mutate('cart/update.js', function () {
      var fresh = scope.querySelector('[data-cart-edition-swap="' + target + '"]');
      var plan = fresh && editionPlan(fresh, target);
      if (!plan) return null;
      setEditionBusy(fresh, true);
      twins = plan.twins;
      return { updates: plan.updates };
    }, { lock: true })
      .then(function (data) {
        if (!data) {
          if (button.isConnected) setEditionBusy(button, false);
          return;
        }
        var found = variantsInCart(data);
        if (!twins.every(function (variant) { return found[variant]; })) throw {};
      })
      .catch(function () {
        C.refresh().catch(noop).then(function () {
          var freshError = scope.querySelector('[data-cart-edition-error]');
          if (freshError) freshError.hidden = false;
        });
      });
  }

  /* ---------------- Codi de descompte ---------------- */
  function sameCode(a, b) {
    return String(a || '').trim().toUpperCase() === String(b || '').trim().toUpperCase();
  }

  // Codis aplicats ara mateix (les etiquetes de la motxilla, pintades amb la darrera resposta): sense un fetch de /cart.js.
  function appliedCodes(scope) {
    return Array.prototype.map.call(scope.querySelectorAll('[data-cart-discount-remove]'), function (button) {
      return button.dataset.code;
    });
  }

  function setBusy(scope, busy) {
    var box = scope.querySelector('[data-cart-discount]');
    if (!box) return;
    box.setAttribute('aria-busy', busy ? 'true' : 'false');
    box.querySelectorAll('button, input').forEach(function (el) { el.disabled = busy; });
  }

  // Mostra el missatge a la motxilla ja repintada. type: applied | invalid | error
  function showDiscountMessage(scope, type, code) {
    var box = scope.querySelector('[data-cart-discount]');
    if (!box) return;
    var msg = box.querySelector('[data-cart-discount-msg]');
    var input = box.querySelector('[data-cart-discount-input]');
    box.open = true;
    if (msg) {
      var key = type === 'applied' ? 'msgApplied' : type === 'invalid' ? 'msgInvalid' : 'msgError';
      msg.textContent = box.dataset[key] || '';
      msg.classList.toggle('is-success', type === 'applied');
      msg.classList.toggle('is-error', type !== 'applied');
      msg.hidden = !msg.textContent;
    }
    if (input) {
      if (type === 'applied') {
        input.value = '';
        input.removeAttribute('aria-invalid');
      } else {
        if (code) input.value = code;
        input.setAttribute('aria-invalid', 'true');
        input.focus({ preventScroll: true });
      }
    }
  }

  function applyDiscount(scope) {
    var C = cart();
    var input = scope.querySelector('[data-cart-discount-input]');
    if (!C || !input) return;
    var code = input.value.trim();
    if (!code) { input.focus(); return; }
    var current = appliedCodes(scope);
    if (current.some(function (c) { return sameCode(c, code); })) {
      showDiscountMessage(scope, 'applied', code);
      return;
    }
    setBusy(scope, true);
    C.setBusy(true);
    C.run(function () {
      return C.request('cart/update.js', { discount: current.concat(code).join(',') }).then(function (updated) {
        var entry = (updated.discount_codes || []).filter(function (d) { return sameCode(d.code, code); })[0];
        if (entry && entry.applicable) {
          C.render(updated.sections);
          return 'applied';
        }
        // No aplica: es treu perquè no quedi pendent i amagat a la motxilla.
        return C.request('cart/update.js', { discount: current.join(',') }).then(function (reverted) {
          C.render(reverted.sections);
          return 'invalid';
        });
      });
    }).then(function (result) {
      C.setBusy(false);
      showDiscountMessage(scope, result, code);
    }, function () {
      C.setBusy(false);
      setBusy(scope, false);
      showDiscountMessage(scope, 'error', code);
    });
  }

  function removeDiscount(scope, code) {
    var C = cart();
    if (!C) return;
    var rest = appliedCodes(scope).filter(function (c) { return !sameCode(c, code); });
    setBusy(scope, true);
    C.mutate('cart/update.js', { discount: rest.join(',') })
      .then(function () {
        var box = scope.querySelector('[data-cart-discount]');
        if (box) {
          box.open = true;
          var input = box.querySelector('[data-cart-discount-input]');
          if (input) input.focus({ preventScroll: true });
        }
      })
      .catch(function () {
        setBusy(scope, false);
        showDiscountMessage(scope, 'error');
      });
  }

  /* ---------------- Esdeveniments (delegats: el contingut es torna a pintar) ---------------- */
  document.addEventListener('click', function (event) {
    var swap = event.target.closest('[data-cart-upsell-swap]');
    if (swap) {
      event.preventDefault();
      if (!swap.disabled) swapForPack(swap);
      return;
    }
    var edition = event.target.closest('[data-cart-edition-swap]');
    if (edition) {
      event.preventDefault();
      if (!edition.disabled) swapEdition(edition);
      return;
    }
    var apply = event.target.closest('[data-cart-discount-apply]');
    if (apply) {
      event.preventDefault();
      applyDiscount(scopeOf(apply));
      return;
    }
    var remove = event.target.closest('[data-cart-discount-remove]');
    if (remove) {
      event.preventDefault();
      removeDiscount(scopeOf(remove), remove.dataset.code);
    }
  });

  // Enter dins el camp del codi: aplica el codi (sense això enviaria el formulari i aniria al pagament).
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter') return;
    var input = event.target.closest && event.target.closest('[data-cart-discount-input]');
    if (!input) return;
    event.preventDefault();
    applyDiscount(scopeOf(input));
  });
})();
